<template>
  <div>
    <!-- Cabeçalho -->
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h5 class="mb-0">Operadores de Pagamento</h5>
      <!-- Botão Novo Cadastro -->
      <b-button
        v-if="hasPermission('adicionar_parametros_operadores')"
        variant="primary"
        class="d-flex align-items-center"
        @click="irParaCadastro"
      >
        <i class="bi bi-plus-circle-fill mr-2" title="Novo Cadastro"></i>
      </b-button>
    </div>

    <!-- Filtros -->
    <div class="d-flex mb-3" style="gap: 10px;">
      <input
        v-model="filters.operador"
        placeholder="Filtrar por operador"
        class="form-control mr-2"
        @input="filtrarOperadores"
      />
      <!-- Filtro para Ativo -->
      <select
        v-model="filters.ativo"
        @change="filtrarOperadores"
        class="form-select form-control"
        style="width: 200px;"
      >
        <option value="" disabled hidden>Selecione o status</option>
        <option value="">Todos</option>
        <option value="true">Ativo</option>
        <option value="false">Inativo</option>
      </select>
      <!-- Botão Limpar Filtros -->
      <b-button
        variant="secondary"
        @click="limparFiltros"
        class="d-flex align-items-center justify-content-center"
      >
        <i class="bi bi-funnel mr-2" title="Limpar Filtro"></i>
      </b-button>
    </div>

    <!-- Tabela -->
    <b-table
      :items="operadores"
      :fields="fields"
      striped
      hover
      @sort-changed="onSortChanged"
    >
      <template #cell(ativo)="row">
        {{ row.item.ativo ? 'Sim' : 'Não' }}
      </template>

      <!-- Template para coluna "Criado" -->
      <template #cell(criado_em)="row">
        {{ formatDate(row.item.criado_em) }}
      </template>

      <!-- Template para coluna "Atualizado" -->
      <template #cell(atualizado_em)="row">
        {{ formatDate(row.item.atualizado_em) }}
      </template>
    

      <template #cell(actions)="row">
        <div class="text-end">
          <!-- Botão Detalhar -->
          <i
            v-if="hasPermission('detalhar_parametros_operadores')"
            class="bi bi-eye-fill text-primary mx-2"
            title="Detalhar"
            @click="detalharOperador(row.item.id)"
          ></i>
          <!-- Botão Editar -->
          <i
            v-if="hasPermission('alterar_parametros_operadores')"
            class="bi bi-pencil-fill text-warning mx-2"
            title="Editar"
            @click="editarOperador(row.item.id)"
          ></i>
          <!-- Botão Excluir -->
          <i
            v-if="hasPermission('excluir_parametros_operadores')"
            class="bi bi-trash-fill text-danger mx-2"
            title="Excluir"
            @click="excluirOperador(row.item.id)"
          ></i>
        </div>
      </template>
    </b-table>

    <!-- Controles de Paginação -->
    <div class="d-flex justify-content-center align-items-center mt-3" style="gap: 10px;">
      <!-- Botão Anterior -->
      <b-button
        @click="paginaAnterior"
        :disabled="paginaAtual === 1"
        variant="light"
        class="p-1 d-flex align-items-center"
      >
        <i class="bi bi-chevron-left"></i>
      </b-button>

      <!-- Numeração de Página -->
      <span>Página {{ paginaAtual }} de {{ totalPaginas }}</span>

      <!-- Botão Próxima -->
      <b-button
        @click="proximaPagina"
        :disabled="paginaAtual >= totalPaginas"
        variant="light"
        class="p-1 d-flex align-items-center"
      >
        <i class="bi bi-chevron-right"></i>
      </b-button>

      <!-- Seleção de Registros por Página -->
      <select
        v-model="limitePorPagina"
        @change="alterarLimite"
        class="form-select form-select-sm"
        style="width: 10%;"
      >
        <option value="10">10 registros</option>
        <option value="15">15 registros</option>
        <option value="20">20 registros</option>
      </select>
    </div>
  </div>
</template>

<script>
import axios from "@/services/axios";
import { BButton, BTable } from "bootstrap-vue-next";

export default {
  components: { BButton, BTable },
  data() {
    return {
      operadores: [],
      fields: [
        { key: "operador", label: "Operador", sortable: true },
        { key: "ativo", label: "Ativo", sortable: true },
        { key: "criado_em", label: "Criado", sortable: true },
        { key: "atualizado_em", label: "Atualizado", sortable: true },
        { key: "actions", label: "Ações", class: "text-end" },
      ],
      filters: { operador: '', ativo: '' },
      paginaAtual: 1,
      limitePorPagina: 10,
      totalPaginas: 1,
      currentSort: { key: "operador", order: "asc" },
    };
  },
  methods: {
    async carregarOperadores() {
      try {
        const response = await axios.get('/financeiro/parametros/operadores', {
          params: {
            page: this.paginaAtual,
            limit: this.limitePorPagina,
            operador: this.filters.operador || undefined,
            ativo: this.filters.ativo !== "" ? this.filters.ativo : undefined,
            sortBy: this.currentSort.key,
            order: this.currentSort.order,
          },
        });
        // Acesse o array de operadores em response.data.data
        this.operadores = response.data.data.map(item => ({
          ...item,
          ativo: !!item.ativo,
        }));
        this.totalPaginas = response.data.totalPages;
      } catch (error) {
        console.error('Erro ao carregar operadores:', error.message);
      }
    },

    formatDate(data) {
      if (!data) return "Não informado";
      return new Date(data).toLocaleString();
    },


    alterarLimite() {
      this.paginaAtual = 1;
      this.carregarOperadores();
    },
    filtrarOperadores() {
      this.paginaAtual = 1;
      this.carregarOperadores();
    },
    async excluirOperador(id) {
      // Exibe o modal de confirmação customizado e aguarda a resposta do usuário
      const confirmou = await this.$confirm(
        "Tem certeza que deseja excluir este operador?",
        "Confirmação"
      );

      if (confirmou) {
        try {
          await axios.delete(`/financeiro/parametros/operadores/${id}`, {
            validateStatus: function (status) {
              return status >= 200 && status < 300; // Apenas status 2xx serão considerados sucesso
            }
          });

          // Atualiza a listagem após a exclusão bem-sucedida
          this.carregarOperadores();
          this.$toast.success("Operador excluído com sucesso!");
        } catch (error) {
          console.error("Erro ao excluir operador:", error);

          let mensagem = "Erro inesperado ao excluir operador.";
          if (error.response && error.response.data) {
            mensagem = error.response.data.error || "Erro ao excluir operador.";
          }
          
          // Exibe o alerta customizado com a mensagem de erro
          await this.$alert(mensagem, "Não permitido");
        }
      }
    },
    onSortChanged(ctx) {
      this.currentSort.key = ctx.sortBy;
      this.currentSort.order = ctx.sortDesc ? 'desc' : 'asc';
      this.carregarOperadores();
    },
    paginaAnterior() {
      if (this.paginaAtual > 1) {
        this.paginaAtual--;
        this.carregarOperadores();
      }
    },
    proximaPagina() {
      if (this.paginaAtual < this.totalPaginas) {
        this.paginaAtual++;
        this.carregarOperadores();
      }
    },
    limparFiltros() {
      this.filters.operador = '';
      this.paginaAtual = 1;
      this.carregarOperadores();
    },
    irParaCadastro() {
      this.$router.push('/financeiro/parametros/operadores/novo');
    },
    editarOperador(id) {
      this.$router.push(`/financeiro/parametros/operadores/${id}`);
    },
    detalharOperador(id) {
      this.$router.push(`/financeiro/parametros/operadores/${id}/detalhar`);
    },
  },
  async mounted() {
    await this.fetchPermissions();
    this.carregarOperadores();
  },
};
</script>
